import { render, staticRenderFns } from "./ZddShare.vue?vue&type=template&id=230a145c&scoped=true"
import script from "./ZddShare.vue?vue&type=script&lang=js"
export * from "./ZddShare.vue?vue&type=script&lang=js"
import style0 from "./ZddShare.vue?vue&type=style&index=0&id=230a145c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a145c",
  null
  
)

export default component.exports